var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("q-form", { ref: "editForm" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "기본정보" },
                },
                [
                  _c(
                    "template",
                    { slot: "card-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _vm.editable
                            ? _c("c-btn", {
                                attrs: {
                                  label: "일지출력",
                                  color: "amber-7",
                                  icon: "print",
                                },
                              })
                            : _vm._e(),
                          _vm.editable
                            ? _c("c-btn", {
                                attrs: {
                                  label: "전체화면 보기",
                                  icon: "receipt_long",
                                },
                                on: { btnClicked: _vm.fullScreenReport },
                              })
                            : _vm._e(),
                          _vm.editable
                            ? _c("c-btn", {
                                attrs: { label: "저장", icon: "save" },
                              })
                            : _vm._e(),
                          _vm.editable
                            ? _c("c-btn", {
                                attrs: { label: "삭제", icon: "remove" },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-datepicker", {
                          attrs: { label: "작성일", name: "col1" },
                          model: {
                            value: _vm.data.col1,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "col1", $$v)
                            },
                            expression: "data.col1",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-field", {
                          attrs: {
                            editable: _vm.editable,
                            data: _vm.data,
                            deptValue: "col2",
                            type: "dept_user",
                            label: "작성부서 & 작성자",
                            name: "col3",
                          },
                          model: {
                            value: _vm.data.col3,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "col3", $$v)
                            },
                            expression: "data.col3",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("c-plant", {
                          attrs: {
                            required: "true",
                            type: "edit",
                            name: "col0",
                          },
                          model: {
                            value: _vm.data.col0,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "col0", $$v)
                            },
                            expression: "data.col0",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("c-select", {
                          attrs: {
                            comboItems: _vm.whetherItems,
                            type: "edit",
                            itemText: "codeName",
                            itemValue: "code",
                            name: "col4",
                            label: "날씨",
                          },
                          model: {
                            value: _vm.data.col4,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "col4", $$v)
                            },
                            expression: "data.col4",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "온도",
                            suffix: "℃",
                            name: "col5",
                          },
                          model: {
                            value: _vm.data.col5,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "col5", $$v)
                            },
                            expression: "data.col5",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tabvertical",
            },
            [
              _c("c-tab", {
                attrs: {
                  type: "vertical",
                  tabItems: _vm.tabItems,
                  inlineLabel: true,
                  dense: true,
                  align: "left",
                  height: _vm.tabHeight,
                  splitter: _vm.splitter,
                  tabClass: "bg-teal-2 text-gray-9 shadow-2",
                  tabClassVertical: "leftTabAlign",
                },
                on: {
                  "update:tabItems": function ($event) {
                    _vm.tabItems = $event
                  },
                  "update:tab-items": function ($event) {
                    _vm.tabItems = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (tab) {
                      return [
                        _c(tab.component, {
                          tag: "component",
                          attrs: { param: _vm.popupParam },
                        }),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }